import React, { useState } from 'react';
import { Upload, Spin, Button } from 'antd';
import { UploadProps } from 'antd/es/upload';
import { LoadingOutlined } from '@ant-design/icons';

interface IGenericDraggerProps {
    disabled?: boolean;
    isUploading?: boolean;
    uploadingText?: string;
    title?: React.ReactNode;
    description?: React.ReactNode;
    footer?: React.ReactNode;
    uploadProps: UploadProps; // Pass Antd props directly
    onBrowseClick?: () => void;
    className?: string;
    showIcon?: boolean;
}

export const GenericUploadDragger: React.FC<IGenericDraggerProps> = ({
    disabled,
    isUploading,
    uploadingText = 'Uploading...',
    title,
    description,
    footer,
    uploadProps,
    onBrowseClick,
    className,
    showIcon = true,
}) => {
    const [dragOver, setDragOver] = useState(false);

    return (
        <div
            onDragOver={e => {
                e.preventDefault();
                setDragOver(true);
            }}
            onDragLeave={e => {
                e.preventDefault();
                setDragOver(false);
            }}
            className={className}
        >
            <Upload.Dragger
                {...uploadProps}
                disabled={disabled}
                className={`border-3 border-dashed rounded-xl p-12 mb-8 transition-all duration-300 p-4 ${
                    dragOver
                        ? 'border-blue-500 bg-gradient-to-br-from-blue-50-to-blue-100 shadow-inner scale-[1.02]'
                        : 'border-slate-300 bg-gradient-slate-to-blue hover:border-blue-400 hover:bg-blue-50'
                }`}
            >
                {isUploading ? (
                    <Spin indicator={<LoadingOutlined />} tip={uploadingText} />
                ) : (
                    <div className="text-center">
                        {showIcon && (
                            <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
                                <svg
                                    className="w-8 h-8 svg-primary-color"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                    />
                                </svg>
                            </div>
                        )}

                        <div className="text-xl  text-slate-700 mb-2">{title}</div>
                        <div className="text-slate-600 mb-4">{description}</div>

                        {onBrowseClick && (
                            <Button
                                onClick={onBrowseClick}
                                type="ghost"
                                style={{
                                    borderColor: '#c00',
                                    color: '#c00',
                                }}
                            >
                                Browse Files
                            </Button>
                        )}

                        <div className="mt-4">{footer}</div>
                    </div>
                )}
            </Upload.Dragger>
        </div>
    );
};
